import {ContentClient} from '@/clients/ContentClient';
import {defineStore} from 'pinia';

export const useItemStore = defineStore('item', {
    state: () => ({
        item: []
    }),
    getters: {
        theContent(state) {
            return state.item;
        }
    },
    actions: {
        async getContentItem(id, mission) {
            let response = await ContentClient.getContentItem(id, mission);
            this.item = response.data;
        },

        async startContentItem(id, mission) {
            await ContentClient.startContentItem(id, mission);
        },

        async completeContentItem(id, mission) {
            await ContentClient.completeContentItem(id, mission);
        }
    }
});